module.exports = __webpack_public_path__ + "static/img/train-bg.f8e2f13d.png";